import { render } from "./UnderTest.vue?vue&type=template&id=6685d2f7"
import script from "./UnderTest.vue?vue&type=script&lang=js"
export * from "./UnderTest.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__